import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { i18n } from '@kostbar/i18n'
import type { RestaurantScheduling } from '@/api/types'
import { ApiError } from '@/api/types'
import { restaurantsApi } from '@/api/endpoints/restaurants'

export function useRestaurantScheduling(restaurantId: number) {
  return useQuery({
    queryKey: ['restaurantScheduling', restaurantId],
    queryFn: () => restaurantsApi.getScheduling(restaurantId),
    staleTime: 0,
  })
}

export function useSaveRestaurantScheduling(restaurantId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: RestaurantScheduling) =>
      restaurantsApi.putScheduling(restaurantId, body),
    onSuccess: () => {
      toast.success(i18n.t('restaurants:scheduling.saved'))
      qc.invalidateQueries({ queryKey: ['restaurantScheduling', restaurantId] })
    },
    onError: (error) => {
      const code = error instanceof ApiError ? error.code : undefined
      toast.error(
        code
          ? `${i18n.t('restaurants:scheduling.saveError')} (${code})`
          : i18n.t('restaurants:scheduling.saveError'),
      )
    },
  })
}
